export const QueryPatentImagesService = Symbol('QueryPatentImagesService');
